export const NotFound: React.FC = () => {
    return (
        <div>
        <h1>Not Found</h1>
        </div>
    )
}